import React, { useState } from "react"
import cn from "classnames"
import { GithubPicker } from "react-color"
import {
  makeTransparent,
  DEFAULT_COLOR,
} from "src/containers/Calendar/helpers/eventToItem"
import styles from "./styles.css"

const COLORS = [
  `#44bcf5`,
  `#7086e7`,
  `#956ce0`,
  `#3d69a6`,
  `#5f7d8c`,
  `#25a89b`,
  `#b3ac19`,
  `#8cb25d`,
  `#429b3f`,
  `#c28e41`,
  `#ab7763`,
  `#7d363e`,
  `#e87c5a`,
  `#e7628f`,
]

const ColorPicker = ({
  value,
  formValue,
  setFormValue,
  isDisabled = false,
}) => {
  const [isVisible, toggle] = useState(false)
  return (
    <div className={styles[`picker-container`]}>
      <button
        type="button"
        onClick={toggle}
        className={cn(styles[`circle-wrapper`], {
          [styles[`circle-wrapper_disabled`]]: isDisabled,
        })}
        disabled={isDisabled}
      >
        <div
          className={styles.circle}
          style={{
            backgroundColor: `${
              value === `#fff` ? DEFAULT_COLOR : makeTransparent(value, 0.4)
            }`,
          }}
        />
      </button>
      {isVisible && (
        <div>
          <GithubPicker
            triangle="top-right"
            className={styles[`color-palette`]}
            colors={COLORS}
            width="248px"
            onChangeComplete={({ hex }) => {
              setFormValue({ ...formValue, color: hex })
              toggle(false)
            }}
          />
          <div
            className={styles[`color-picker-overlay`]}
            onClick={() => toggle(false)}
          />
        </div>
      )}
    </div>
  )
}

export default ColorPicker
